import { useConfigContext } from "shared/hooks";

import PopupMessagesIframe from "./PopupMessagesIframe";
import PopupMessagesNonIframe from "./PopupMessagesNonIframe";
import { Props } from "./types";

import "./index.css";

function PopupMessages(props: Props) {
  const { isIframe } = useConfigContext();
  if (isIframe) {
    return <PopupMessagesIframe {...props} />;
  }
  return <PopupMessagesNonIframe {...props} />;
}

export default PopupMessages;
